module.exports = __webpack_public_path__ + "static/media/storeIcon.76062a10.png";